module.exports = __webpack_public_path__ + "static/media/npm.b360eba6.png";